export class DeviceDetector {
  static isIos() {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return true;
    }

    if (/android/i.test(userAgent)) {
      return false;
    }
  }

  static isMobile() {
    return /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent);
  }
}
